import classNames from 'classnames';
import { FieldProps, useFormikContext } from 'formik';
import { useCallback } from 'react';
import UDFormFieldWrapper from 'ud-form/wrapper';
import { UDFormComponentProps } from '../types';
import { UDCreatableSelect, UDCreatableSelectProps } from './component';

type UDFormCreatableSelectProps<isMulti extends boolean> = UDFormComponentProps & UDCreatableSelectProps<isMulti>;

type Returning = <isMulti extends boolean = false>(props: UDFormCreatableSelectProps<isMulti>) => JSX.Element;

const UDFormCreatableSelect: Returning = (props) => {
  const { name, containerProps, required, label, labelProps, ...otherSelectProps } = props;

  const { setFieldValue } = useFormikContext();
  const onChange = useCallback(
    (value: any, isMulti: any) => {
      setFieldValue(name, value);

      if (props.onChange) {
        props.onChange(value, isMulti);
      }
    },
    [name, setFieldValue],
  );
  return (
    <UDFormFieldWrapper name={name} containerProps={containerProps} label={label} labelProps={labelProps} required={required}>
      {({ field, meta }: FieldProps<any>) => (
        <UDCreatableSelect
          {...otherSelectProps}
          {...field}
          className={classNames('w-full', otherSelectProps?.className)}
          onChange={onChange}
          hasError={Boolean(meta.error)}
        />
      )}
    </UDFormFieldWrapper>
  );
};

export default UDFormCreatableSelect;
